import { render, staticRenderFns } from "./SMSStats.vue?vue&type=template&id=984ae5b6&scoped=true&"
import script from "./SMSStats.vue?vue&type=script&lang=js&"
export * from "./SMSStats.vue?vue&type=script&lang=js&"
import style0 from "./SMSStats.vue?vue&type=style&index=0&id=984ae5b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984ae5b6",
  null
  
)

export default component.exports